import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { OrganizationPricingItem } from './OrganizationPricingItem';
import type { FeeSummary } from './utils/feeSummary';
import { PARTNER_TYPE_LABELS } from './utils/labels';
import { PartnerType } from './utils/partnerFeeRows';

type FeeSummarySectionProps = {
  summary: FeeSummary;
  /** Labels the lines by partner type: set when the deal has partners of both types. */
  isLabelledByType: boolean;
};

/** Fee Summary lines, labelled by partner type when both types are present (even if one has no totals). */
export const FeeSummarySection = ({ summary: { audience, contextual }, isLabelledByType }: FeeSummarySectionProps) => {
  if (!audience && !contextual) {
    return null;
  }

  return (
    <>
      <Divider />
      <Typography
        variant="h3"
        sx={{
          mt: 2,
          mb: 2,
        }}
      >
        Fee Summary
      </Typography>
      {audience ? (
        <OrganizationPricingItem
          pricing={audience}
          title={
            isLabelledByType ? PARTNER_TYPE_LABELS[PartnerType.AUDIENCE].feeSummaryTitle[audience.type] : undefined
          }
        />
      ) : null}
      {contextual ? (
        <OrganizationPricingItem
          pricing={contextual}
          title={
            isLabelledByType ? PARTNER_TYPE_LABELS[PartnerType.CONTEXTUAL].feeSummaryTitle[contextual.type] : undefined
          }
        />
      ) : null}
    </>
  );
};
